import { useState } from 'react';

import { Button, Group, Modal, SimpleGrid, Text } from '@mantine/core';

import { CompanyProfile } from 'models';

import { CompanyButton } from 'components/company-button/CompanyButton';
import { useCurrentTeamCompanies } from 'hooks/use-current-team-companies';

type Props = {
    opened: boolean;
    close: () => void;
    selectCompany: (company: CompanyProfile) => void;
    partner: CompanyProfile;
};

export const SelectProfileDialog = ({ opened, close, selectCompany, partner }: Props) => {
    const { companies } = useCurrentTeamCompanies();

    const [selectedCompany, setSelectedCompany] = useState<CompanyProfile | null>(null);

    return (
        <Modal opened={opened} withCloseButton onClose={close} size="lg" title={`Add ${partner.name} as partner`}>
            <Text mb="xs">Add {partner.name} as partner to the following profile:</Text>

            <SimpleGrid cols={{ base: 2, sm: 4 }} spacing={8}>
                {companies.map((company) => (
                    <CompanyButton
                        key={company.id}
                        company={company}
                        onClick={() => setSelectedCompany(company)}
                        selected={selectedCompany?.id === company.id}
                    />
                ))}
            </SimpleGrid>
            <Group justify="center" p="md">
                <Button
                    onClick={() => {
                        selectCompany(selectedCompany!);
                        close();
                    }}
                    disabled={!selectedCompany}
                >
                    Add as partner
                </Button>
            </Group>
        </Modal>
    );
};
